import { Injectable } from "@angular/core";
import { IOC } from "@smallstack/core-common";
import { SmallstackTypeRegistry } from "@smallstack/typesystem";
import { FrontendSchemaService } from "./frontend-schema.service";
import { StoreRegistry } from "./store.registry";
import * as i0 from "@angular/core";
import * as i1 from "./frontend-schema.service";
import * as i2 from "./store.registry";
export class FrontendTypeRegistry extends SmallstackTypeRegistry {
    constructor(schemaService, storeRegistry) {
        super();
        this.schemaService = schemaService;
        this.storeRegistry = storeRegistry;
        IOC.register("typeRegistry", this);
    }
    getCrud(typeName) {
        return this.storeRegistry.getStore(typeName);
    }
    async getSchema(typeName) {
        return this.schemaService.getSchemaByName(typeName);
    }
}
FrontendTypeRegistry.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: FrontendTypeRegistry, deps: [{ token: i1.FrontendSchemaService }, { token: i2.StoreRegistry }], target: i0.ɵɵFactoryTarget.Injectable });
FrontendTypeRegistry.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: FrontendTypeRegistry, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: FrontendTypeRegistry, decorators: [{
            type: Injectable,
            args: [{ providedIn: "root" }]
        }], ctorParameters: function () { return [{ type: i1.FrontendSchemaService }, { type: i2.StoreRegistry }]; } });
